import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Edit3, X } from "lucide-react";
import api from "@/lib/api";

const EMPTY = { pincode: "", city: "", state: "", delivery_fee: 49, express: false, active: true };

export default function AdminPincodes() {
  const [pins, setPins] = useState([]);
  const [q, setQ] = useState("");
  const [editing, setEditing] = useState(null);
  const [open, setOpen] = useState(false);

  const load = () => api.get("/pincodes").then((r) => setPins(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      const payload = { ...editing, delivery_fee: Number(editing.delivery_fee) };
      if (editing.id) await api.put(`/admin/pincodes/${editing.id}`, payload);
      else await api.post("/admin/pincodes", payload);
      toast.success("Saved"); setOpen(false); setEditing(null); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  const del = async (id) => {
    if (!window.confirm("Remove this pincode?")) return;
    await api.delete(`/admin/pincodes/${id}`);
    toast.success("Removed"); load();
  };

  const filtered = pins.filter((p) => !q || p.pincode.includes(q) || p.city.toLowerCase().includes(q.toLowerCase()) || p.state.toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <div className="flex justify-between items-center flex-wrap gap-3">
        <div>
          <div className="overline">Coverage</div>
          <h1 className="font-display text-3xl mt-1">Pincodes</h1>
          <p className="text-sm text-[#6C665F] mt-1">Manage where you deliver across India ({pins.length} active).</p>
        </div>
        <div className="flex gap-2">
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search pincode/city/state" className="input-eko" data-testid="pincode-search" />
          <button data-testid="admin-add-pincode" className="btn-primary" onClick={() => { setEditing({ ...EMPTY }); setOpen(true); }}><Plus className="w-4 h-4" /> Add</button>
        </div>
      </div>

      <div className="mt-6 admin-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F4F2EC] text-left">
            <tr>
              <th className="p-4">Pincode</th><th className="p-4">City</th><th className="p-4">State</th><th className="p-4">Fee</th><th className="p-4">Same-day</th><th className="p-4">Active</th><th className="p-4"></th>
            </tr>
          </thead>
          <tbody data-testid="admin-pincodes-table">
            {filtered.map((p) => (
              <tr key={p.id} className="border-t border-[#E5DFD3]">
                <td className="p-4 font-mono">{p.pincode}</td>
                <td className="p-4">{p.city}</td>
                <td className="p-4">{p.state}</td>
                <td className="p-4">₹{p.delivery_fee}</td>
                <td className="p-4">{p.express ? <span className="inline-block px-2 py-0.5 text-xs bg-[#8C3A3A] text-white rounded-full">Yes</span> : "No"}</td>
                <td className="p-4">{p.active ? "Yes" : "No"}</td>
                <td className="p-4 flex gap-2">
                  <button onClick={() => { setEditing(p); setOpen(true); }} className="p-2 hover:bg-[#F4F2EC] rounded"><Edit3 className="w-4 h-4" /></button>
                  <button onClick={() => del(p.id)} className="p-2 hover:bg-[#F4F2EC] rounded text-[#8C3A3A]"><Trash2 className="w-4 h-4" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open && editing && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="bg-white rounded-2xl w-full max-w-md p-6" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-4">
              <div className="font-display text-2xl">{editing.id ? "Edit Pincode" : "New Pincode"}</div>
              <button onClick={() => setOpen(false)}><X className="w-5 h-5" /></button>
            </div>
            <div className="space-y-3">
              <input placeholder="Pincode (6 digits)" className="input-eko" value={editing.pincode} onChange={(e) => setEditing({ ...editing, pincode: e.target.value })} data-testid="pcf-pincode" />
              <input placeholder="City" className="input-eko" value={editing.city} onChange={(e) => setEditing({ ...editing, city: e.target.value })} data-testid="pcf-city" />
              <input placeholder="State" className="input-eko" value={editing.state} onChange={(e) => setEditing({ ...editing, state: e.target.value })} data-testid="pcf-state" />
              <input type="number" placeholder="Delivery fee ₹" className="input-eko" value={editing.delivery_fee} onChange={(e) => setEditing({ ...editing, delivery_fee: e.target.value })} data-testid="pcf-fee" />
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={!!editing.express} onChange={(e) => setEditing({ ...editing, express: e.target.checked })} data-testid="pcf-express" /> Same-day / Midnight delivery available</label>
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={editing.active} onChange={(e) => setEditing({ ...editing, active: e.target.checked })} /> Active</label>
            </div>
            <div className="mt-6 flex justify-end gap-2">
              <button onClick={() => setOpen(false)} className="btn-outline">Cancel</button>
              <button onClick={save} className="btn-primary" data-testid="pcf-save">Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
